var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6872 20.019C11.4515 21.0441 12.949 21.0441 13.7132 20.019C15.6602 17.4075 18.795 12.8128 18.795 10.3017C18.795 6.65947 15.8424 3.70691 12.2002 3.70691C8.55803 3.70691 5.60547 6.65947 5.60547 10.3017C5.60547 12.8128 8.74025 17.4075 10.6872 20.019ZM12.2002 13.2439C13.8812 13.2439 15.244 11.8812 15.244 10.2002C15.244 8.51919 13.8812 7.15647 12.2002 7.15647C10.5192 7.15647 9.15649 8.51919 9.15649 10.2002C9.15649 11.8812 10.5192 13.2439 12.2002 13.2439Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2227,
    cy: 10.2005,
    r: 3.18164,
    fill: "transperent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLocation);
export default __webpack_public_path__ + "static/media/dash-location.ef89a7320cf517a283b9595e197c999e.svg";
export { ForwardRef as ReactComponent };